export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";